// extracted by mini-css-extract-plugin
export default {"header":"Appbar_header__tXRnu"};